import React from "react";
import moment from "moment";
import ButtonIcon from "../../../components/ButtonIcon/ButtonIcon";
import useCommonStore from "../../../stores/common";
import style from "../Application.module.scss";
import AppStatusDot from "./AppStatusDot/AppStatusDot";
import Checkbox from "../../../components/Checkbox/Index";
import useApplicationStore from "../../../stores/application";
import ChildAppCard from "./ChildAppCard";
import { useMediaQuery } from "../../../hooks/useMediaQuery";
import KebabIcon from "../../../assets/svg/icons/common/kebab";

function ChildRow({ children, organization, app }) {
  const showDetails = useCommonStore((state) => state.showDetails);
  const setShowDetails = useCommonStore((state) => state.setShowDetails);
  const setActiveApp = useApplicationStore((state) => state.setActiveApp);
  const selectedApps = useApplicationStore((state) => state.selectedApps);
  const isMobile = useMediaQuery(768);

  const updateSelectedApps = (event) => {
    const appId = +event.target.value;
    useApplicationStore.setState((prevState) => ({
      selectedApps: event.target.checked
        ? [...prevState.selectedApps, appId]
        : prevState.selectedApps.filter((id) => id !== appId),
    }));
  };

  if (isMobile) {
    return (
      <div className={style.mobile_child_apps_container}>
        <ChildAppCard
          child={app}
          organization={organization}
          parentApp={app}
          isParent={true}
        />
        {children.map((child, index) => (
          <ChildAppCard
            key={index}
            child={child}
            organization={organization}
            parentApp={app}
            isParent={false}
          />
        ))}
      </div>
    );
  }

  return (
    <>
      <tr
        className={`${style.child_app} ${style.line} ${style.border_bottom}`}
        onClick={() => {
          setActiveApp(app);
          setShowDetails(true);
        }}
      >
        <td></td>
        <td>
          <div className={style.dba_name}>
            <Checkbox
              value={app.id}
              onChange={(event) => updateSelectedApps(event)}
              checked={selectedApps.includes(app.id)}
            />
            <span>{app.field_dba}</span>
          </div>
        </td>
        <td>
          <div className="status">
            <AppStatusDot progression_id={app?.lead_progression_id} />
          </div>
        </td>
        {!showDetails && <td>{app?.id}</td>}
        <td>{organization}</td>
        {!showDetails && (
          <>
            <td>
              ${" "}
              {app?.bankinfo?.maxsales
                ? parseInt(app?.bankinfo?.maxsales)
                    .toFixed(2)
                    ?.toLocaleString("en-US")
                : "0.00"}
            </td>
            <td>{moment(app?.created_at).format("MMM D, YYYY")}</td>
          </>
        )}
        {/* TODO: Add alerts column will do later */}
        {/* <td>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <circle cx="8" cy="8" r="7" fill="#E03B24" fillOpacity="0.2" />
            <circle cx="8" cy="8" r="3" fill="#E03B24" />
          </svg>
        </td> */}
        {!showDetails && (
          <td>
            <ButtonIcon bgColor={"#F6F6F9"}>
              <KebabIcon />
            </ButtonIcon>
          </td>
        )}
      </tr>

      {children.map((child, index) => (
        <tr
          key={index}
          className={`${style.child_app} ${children.length == index + 1 ? "" : style.line} ${children.length == index + 1 ? "" : style.child_app_br_bottom} ${style.border_bottom}`}
          onClick={() => {
            setActiveApp(child);
            setShowDetails(true);
          }}
        >
          <td></td>
          <td>
            <div className={style.dba_name}>
              <Checkbox
                value={child.id}
                onChange={(event) => updateSelectedApps(event)}
                checked={selectedApps.includes(child.id)}
              />
              <span>{child?.bank?.name}</span>
            </div>
          </td>
          <td>
            <div className="status">
              <AppStatusDot progression_id={child?.lead_progression_id} />
            </div>
          </td>
          {!showDetails && <td>{child.id}</td>}
          <td>{organization}</td>
          {!showDetails && (
            <>
              <td>
                ${" "}
                {child?.bankinfo?.maxsales
                  ? parseInt(child?.bankinfo?.maxsales)
                      .toFixed(2)
                      ?.toLocaleString("en-US")
                  : "0.00"}
              </td>
              <td>{moment(child.created_at).format("MMM D, YYYY")}</td>
            </>
          )}
          {/* <td>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <circle cx="8" cy="8" r="7" fill="#E03B24" fillOpacity="0.2" />
              <circle cx="8" cy="8" r="3" fill="#E03B24" />
            </svg>
          </td> */}
          {!showDetails && (
            <td>
              <ButtonIcon bgColor={"#F6F6F9"}>
                <KebabIcon />
              </ButtonIcon>
            </td>
          )}
        </tr>
      ))}
    </>
  );
}

export default ChildRow;
